export var AnswerTypes;
(function (AnswerTypes) {
    AnswerTypes["shortText"] = "shortText";
    AnswerTypes["paragraph"] = "paragraph";
    AnswerTypes["radioButton"] = "radioButton";
    AnswerTypes["checkboxes"] = "checkboxes";
    AnswerTypes["dropdown"] = "dropdown";
    AnswerTypes["number"] = "number";
    AnswerTypes["date"] = "date";
    AnswerTypes["label"] = "label";
    AnswerTypes["time"] = "time";
})(AnswerTypes || (AnswerTypes = {}));
export var ValidationRuleTypes;
(function (ValidationRuleTypes) {
    ValidationRuleTypes["range"] = "range";
    ValidationRuleTypes["max"] = "max";
    ValidationRuleTypes["min"] = "min";
    ValidationRuleTypes["regex"] = "regex";
    ValidationRuleTypes["match"] = "match";
})(ValidationRuleTypes || (ValidationRuleTypes = {}));
